// uiUtils.ts - Shared UI utility functions for modal/form patterns

/**
 * Show a modal by removing 'hidden' and adding 'active'.
 * Optionally focuses an element within the modal.
 */
export function openModal(modalEl: HTMLElement | null, focusEl: HTMLElement | null = null): void {
    if (!modalEl) return;
    modalEl.classList.remove('hidden');
    modalEl.classList.add('active');
    if (focusEl) focusEl.focus();
}

/**
 * Hide a modal by removing 'active' and adding 'hidden'.
 */
export function closeModal(modalEl: HTMLElement | null): void {
    if (!modalEl) return;
    modalEl.classList.remove('active');
    modalEl.classList.add('hidden');
}

/**
 * Show an error message in an element.
 */
export function showError(el: HTMLElement | null, message: string): void {
    if (!el) return;
    el.textContent = message;
    el.classList.remove('hidden');
}

/**
 * Hide an error element.
 */
export function hideError(el: HTMLElement | null): void {
    if (!el) return;
    el.textContent = '';
    el.classList.add('hidden');
}

/**
 * Set a button to loading state (disabled + label) or restore it.
 * Returns a restore function for use in finally blocks.
 *
 * Usage:
 *   const restore = setButtonLoading(btn, 'Registering...');
 *   try { await doWork(); } finally { restore(); }
 */
export function setButtonLoading(btn: HTMLButtonElement | null, loadingText: string): () => void {
    if (!btn) return () => {};
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = loadingText;
    return () => {
        btn.disabled = false;
        btn.textContent = originalText;
    };
}
